import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import parse from 'html-react-parser';
import { stripTags } from '../../dom/index.js';
/**
 * The `HtmlDecoder` simply decodes html entities
 *
 * Any actual html markup gets stripped before decoding html entities. If you need to render HTML use {@link SafeHtml}
 *
 * #### Usage
 *
 * ```jsx
 * <HtmlDecoder html="Hello world! &#8211; foo bar &#8211;" />
 * ```
 *
 * @param props Component properties
 *
 * @category React Components
 */
export const HtmlDecoder = ({ html }) => {
    return _jsx(_Fragment, { children: parse(stripTags(html)) });
};
